export default __webpack_public_path__ + "static/media/6.b58c8a55.jpg";